
import PricingPlan from "./PricingPlan";
import CheckoutButton from "@/components/subscription/CheckoutButton";

interface PricingPlansProps {
  billingPeriod: "monthly" | "annually";
}

const PricingPlans = ({ billingPeriod }: PricingPlansProps) => {
  const sharkFeatures = [
    { text: "Unlimited property uploads" },
    { text: "Access to buyers in all markets" },
    { text: "View buyer activity" },
    { text: "Early access to new features" },
    { text: "Priority email & phone support" }
  ];

  return (
    <div className="flex justify-center">
      <div className="max-w-md">
        <PricingPlan
          name="Shark"
          price={billingPeriod === "monthly" ? "$34.99" : "$349.99"}
          originalPrice={billingPeriod === "monthly" ? "$68" : "$680"}
          period={billingPeriod === "monthly" ? "/month" : "/year"}
          description="For serious wholesalers who want to maximize their profits"
          features={sharkFeatures}
          highlight={true}
          highlightText="Start Your Free Trial"
          savingsText={billingPeriod === "annually" ? "Save 49% vs. previous pricing • $69.89 less than monthly" : "Save 49% vs. previous pricing"}
          trialText="30-day free trial"
        />
      </div>
    </div>
  );
};

export default PricingPlans;
